import {createSlice} from '@reduxjs/toolkit';

const facilitiesListSlice = createSlice({
  name: 'facilities',
  initialState: {
    facilityList: []
  },
  reducers: {
    setfacilitiesList: (state, action) => {
      state.facilityList = action.payload;
    }
  },
});

export const selectfacilities = (state) => state.facilities;

export const {
  setfacilitiesList,
} = facilitiesListSlice.actions;

export default facilitiesListSlice.reducer;
